<template>
  <div class="sub-company-page">
    <Banner :bannerUrl="bannerUrl" />
    <div class="container">
      <h2 class="com-top-tile">{{ $t('featureBranchPage.branchTitle') }}</h2>
      <div class="sub-list fs">
        <div class="company-info" v-for="(item, index) in $tm('featureBranchPage.branch')" :key="index">
          <b>{{ item.name }}</b>
          <div>{{ item.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Banner from '@/components/banner'
const bannerUrl = require('@assets/images/banner/company-sub-company.png');

</script>

<style lang="less" scoped>
.sub-company-page {
  margin-bottom: 88px;
  .container {
    margin-top: 80px;
  }
  .sub-list {
    flex-wrap: wrap;
    gap: 36px;
    .company-info {
      background-color: #FAFAFA;
      padding: 23px 41px;
      flex: 1;
      min-width: 40%;
      b {
        font-size: 20px;
        color: #151E2C;
        margin-bottom: 12px;
        line-height: 32px;
        display: inline-block;
      }
      div {
        color: rgba(21, 30, 44, 0.5);
        font-size: 14px;
        line-height: 26px;
      }
    }
  }
}
</style>